import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import React from 'react';
import { isEmbeddedReportElement } from '../../types/guards';
import { type EmbeddedReportElement } from '../../types/aha-editor';

// WARNING: Ensure app/assets/components/aha_editor_field_v2/plugins/EmbeddedReport/EmbeddedReportPastePlugin.tsx is updated if you update this regex.
export const URLRegex =
  /bookmarks\/(?:(custom_pivots|feature_grids|idea_grids|gantt_roadmaps|epic_gantt_roadmaps|initiative_gantt_roadmaps)\/)?(\d+)/;

class SerializerEmbeddedReport extends Serializer {
  static deserialize({
    el,
  }: DeserializeArguments): EmbeddedReportElement | undefined {
    if (!isHTMLElementNode(el)) return;
    if (el.tagName.toLowerCase() !== 'a') return;
    const href = el.getAttribute('href');
    if (!href || !URLRegex.test(href)) return;

    const url = new URL(href);
    const searchParams = new URLSearchParams(url.search);

    const type = searchParams.get('type');

    // this is not a serialized link
    if (!type) return;

    const width = searchParams.get('width');
    const height = searchParams.get('height');
    const bookmarkId = href.match(URLRegex)![2] as `${number}`;

    const payload = {
      name: el.textContent || '',
      bookmarkId,
      type,
    };

    return {
      type: 'embedded-report',
      children: [
        {
          text: '',
        },
      ],
      bookmark_id: bookmarkId,
      bookmark_path: url.pathname,
      resizer_width: Number(width),
      resizer_height: Number(height),
      payload,
    };
  }

  static serialize({ node, options }: SerializeArguments) {
    if (!isEmbeddedReportElement(node)) return;
    if (!node.payload.bookmarkId) return;

    const searchParams = new URLSearchParams();
    node.payload.type && searchParams.set('type', node.payload.type);
    node.resizer_width &&
      searchParams.set('width', node.resizer_width.toString());
    node.resizer_height &&
      searchParams.set('height', node.resizer_height.toString());

    return (
      <a
        href={`${options.baseURL ?? ''}${
          node.bookmark_path ?? `/bookmarks/${node.payload.bookmarkId}`
        }?${searchParams.toString()}`}
      >
        Embedded report
      </a>
    );
  }
}

export default SerializerEmbeddedReport;
